module.exports = __webpack_public_path__ + "img/電気回路_6_6_2.b476bff1.png";